

export const AuthConstants = {
  storageKeys: {
    externalIdentityProviders: {
      gState: 'rag_iss_g_state'
    }
  }
}

export interface ExternalLogonProviderState {
  state: string | number
  createdAt: number
}
